// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    TAG_VIDEO_LOADING() {
      return {
        isLoading: true,
        tagVideo: action.tagVideo
      };
    },
    TAG_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.tagVideo
      };
    },
    TAG_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.tagVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
